var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEhrEpic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 35,
    viewBox: "0 0 96 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2752_28091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.5157 10.6885C85.6838 10.6885 87.1719 11.7605 87.3639 13.6646H95.9883C96.2763 7.44033 91.2201 5.20023 83.5717 5.20023C75.6514 5.20023 69.6671 8.04836 67.155 13.8086L68.8031 6.06427H60.4827L58.9466 13.2646C58.5786 8.27237 54.7865 5.52025 48.6582 5.52025C45.282 5.52025 42.0819 6.7363 39.8578 8.8964H39.7778L40.3698 6.08027H32.2894L29.0893 21.281H10.6085L11.4885 16.5127H27.9693L29.2013 10.7045H12.7206L13.6166 6.03227H32.3214L33.6015 0H5.56825L0 27.3132H27.7932L26.1612 34.9936H34.4815L36.5296 25.3931H36.6096C37.6817 26.9612 40.2578 28.1773 43.938 28.1773C50.2423 28.1773 55.1065 24.9291 57.4426 20.4329L55.9865 27.3132H64.3069L65.923 19.6649C65.971 25.4571 70.5792 28.1773 78.7075 28.1773C87.8759 28.1773 92.7082 24.8491 95.2843 18.9769H86.4999C85.3318 21.457 83.0277 22.689 80.0356 22.689C76.0354 22.689 74.2273 20.5289 75.0434 16.6887C75.8274 12.8486 78.6435 10.6885 82.5157 10.6885ZM50.1623 16.7367C49.4102 20.2729 46.9301 22.145 43.1379 22.145C39.2498 22.145 37.6657 20.0329 38.3697 16.7367C39.0738 13.4406 41.5539 11.3285 45.442 11.3285C49.2342 11.3285 50.9143 13.2006 50.1623 16.7367Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2752_28091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 34.9936,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhrEpic);
export default __webpack_public_path__ + "static/media/ehr-epic.d1bbd0489dd28d70af3bf3d86ecf0af6.svg";
export { ForwardRef as ReactComponent };